/* eslint-disable react/no-children-prop */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';
import Colors from '@global/colors';
import { isWeb } from '@global/screens';
import * as Layout from '@components/screen/Layout';
import Table from '@components/table/Table';
import SociollaText from '@components/sociolla/SociollaText';

import { MsOrder } from '@api/ms-order';
import { downloadFile } from '@global/helpers';

const tableStructure = {
  name: {
    head: 'Name',
    body: 'name',
    textStyle: { fontFamily: 'figtree-medium' },
  },
  url: {
    head: 'Url',
    body: 'url',
    maxWidth: 200,
  },
  action: {
    head: 'Action',
    type: 'action',
    actions: [
      {
        name: 'download',
        label: 'DOWNLOAD',
        style: {
          borderColor: Colors.blue3,
          backgroundColor: Colors.blue3,
        },
        textStyle: { color: Colors.white },
      },
    ],
  },
};

const ReturnOrderDocumentScreen = (props) => {
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    let mounted = true;
    if (mounted && props?.route?.params?.id) {
      getOrderDetail(props.route.params.id);
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  const getOrderDetail = async (id) => {
    setLoading(true);
    try {
      const response = await MsOrder.getSalesOrderDetail(id);
      if (response?.data?.data && Object.keys(response.data.data).length) {
        const result = response.data.data;
        const finalData = result?.attachments?.length ? result.attachments : [];
        setTableData(finalData);
      } else {
        setTableData([]);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  const onDownload = (url) => {
    if (url) {
      downloadFile(url, 'sales-order-document', '', true);
    }
  };

  const onMapAction = ({ data, index, action }) => {
    if (data) {
      if (action.name == 'download') {
        onDownload(data.url);
      }
    }
  };

  return (
    <Layout.Container>
      {isWeb ? (
        <>
          <Layout.Back
            title={props.route.params?.reference || ''}
            onCallback={() =>
              props.navigation.navigate(
                'SalesOrderDetailScreen',
                props.route.params,
              )
            }
          />
          <Layout.Title title={`Attachments ${tableData?.length}`} />
          <Table
            structures={tableStructure}
            data={tableData}
            loading={loading}
            showSearch={false}
            showFilter={false}
            showPagination={false}
            hasCallback
            hasNoHide
            onMapAction={(val) => onMapAction(val)}
          />
        </>
      ) : (
        <ScrollView contentContainerStyle={{ width: '100%' }}>
          {loading ? (
            <Layout.Loader />
          ) : !loading && !tableData?.length ? (
            <View style={styles.noData}>
              <SociollaText style={styles.noDataText}>
                No data found
              </SociollaText>
            </View>
          ) : (
            tableData.map((item, idx) => (
              <Layout.ItemMobile
                touchable
                onPress={() => onDownload(item.url)}
                key={idx}>
                <SociollaText>{item.name}</SociollaText>
              </Layout.ItemMobile>
            ))
          )}
        </ScrollView>
      )}
    </Layout.Container>
  );
};

const styles = StyleSheet.create({
  noData: {
    width: '100%',
    paddingHorizontal: 15,
    paddingVertical: 25,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  noDataText: { fontSize: 13 },
});

export default ReturnOrderDocumentScreen;
